import "rxjs/add/operator/map";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { INSIGHTS } from "constants/action-types";
import type { IStore } from "reducers";
import type { IProductSizeInsightResponse } from "types/insights/product-size-insight";
import { SizeInsights } from "models/insights/size-insights";
import { Observable } from "rxjs/Observable";

export const fetchProductSizeInsightsEpic = (action$, store) =>
    action$.ofType(INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.START).switchMap((action) => {
        const state: IStore = store.getState();
        const brandId = state.scope.brand._id;

        const payloadProductIds = action.payload.productIds;
        const productIds = Array.isArray(payloadProductIds) ? payloadProductIds : [payloadProductIds];

        const query = productIds.map((id) => `products=${id}`).join("&");

        return ajax({
            url: `${siteConfig.orderInsightApi}/insights/brand/${brandId}/sizes?${query}`,
            method: "GET",
            withCredentials: true,
            crossDomain: true,
            headers: {
                "Content-Type": "application/json",
            },
            handle401: true,
        })
            .flatMap(({ response, status }) => {
                if (status !== 200) {
                    throw new Error(response.message || "Unknown fetch error");
                }

                const productsSizes = response as IProductSizeInsightResponse;

                return [
                    {
                        type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.COMPLETED,
                        productSizes: productsSizes?.products.map((product) => new SizeInsights(product)),
                    },
                ];
            })
            .catch((error) => {
                return Observable.merge(
                    Observable.of({
                        type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.ERROR,
                        error: true,
                        payload: new Error(`Error fetching product size insights ${error.message}`),
                    })
                );
            });
    });
